import React from "react";
import clsx from "clsx";
import { Card, Grid, Typography } from '@curves/ui-base';

import ReadTextField from "@Local/Components/ReadTextField";
/**
 * 通用讀取卡片
 * @param {string|ReactNode} title 卡片標題
 * @param {Array} items 欄位設定：[{ label, value, xs=12, sm, md, render, format, placeholder, hideIfEmpty }]
 * @param {number} gridSpacing Grid 間距，預設 3
 * @param {boolean} outlined 是否加實線邊框
 * @param {string} borderColor 邊框色（outlined=true 時生效）
 * @param {string} headerBg 標頭背景色（可用 util 類別或 hex）
 * @param {boolean} raised 是否使用陰影（對應 MUI elevation）
 * @param {boolean} hideEmpty 是否全局隱藏空值欄位（可被 item.hideIfEmpty 覆蓋）
 * @param {string} placeholder 全局無資料占位字
 * @param {string} className 外層卡片 class
 * @param {string} contentClass 內容區 class
 */
const ReadSectionCard = ({
	title,
	items = [],
	gridSpacing = 3,
	outlined = false,
	borderColor = "#ddd",
	headerBg,
	raised = false,
	hideEmpty = false,
	placeholder = "無資料",
	className,
	contentClass,
}) => {
	const headerStyle = headerBg ? { backgroundColor: headerBg } : undefined;
	const cardStyle = outlined ? { border: `1px solid ${borderColor}` } : undefined;
	const renderValue = item => {
		const raw = item.value;
		const formatted = typeof item.format === "function" ? item.format(raw, item) : raw;
		if (item.render) return item.render(formatted, item);
		const hasContent = formatted !== null && formatted !== undefined && !(typeof formatted === "string" && formatted.trim() === "");
		if (!hasContent && (item.hideIfEmpty ?? hideEmpty)) return null;
		return (
			<ReadTextField label={item.label} fullWidth>
				{hasContent ? formatted : item.placeholder ?? placeholder}
			</ReadTextField>
		);
	};
	return (
		<Card className={clsx("read-section-card", className)} raised={raised} style={cardStyle}>
			<Card.CardHeader
				title={
					typeof title === "string" ? (
						<Typography variant="body-1" className="font-weight-900">
							{title}
						</Typography>
					) : (
						title
					)
				}
				style={headerStyle}
			/>
			<Card.CardContent className={clsx("p-4", contentClass)}>
				<Grid container spacing={gridSpacing}>
					{items.map((item, idx) => {
						const node = renderValue(item);
						if (node === null) return null;
						const { xs = 12, sm, md } = item;
						return (
							<Grid key={idx} item xs={xs} sm={sm} md={md}>
								{node}
							</Grid>
						);
					})}
				</Grid>
			</Card.CardContent>
		</Card>
	);
};
export default ReadSectionCard;
